import api from './api';

export async function fetchExperiences(restaurant) {
    if (!restaurant) return {};

    const params = {
        restaurant,
        q: { active: true, deleted: false, private: true, "enabledForGiftCard": true },
        sort: 'order _id',
    };

    params.q = JSON.stringify(params.q);

    const { data } = await api.get(`experience`, {params});
    if (data) return data;
}
